exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group-scroll {\n    max-height: 500px; \n    overflow: scroll; \n    -webkit-overflow-scrolling: touch;\n}\n", ""]);

// exports
